import Vue from 'vue';
import vuexI18n from 'vuex-i18n';
import VueRouter from 'vue-router';
import Notifications from 'vue-notification';
import LoginRouter from '@/login/router/login-router';
import Login from '@/login/components/login/login.vue';
import localeRu from '@/user/localization/ru/index';
import store from '@/common/stores/appStore';
import 'bootstrap';
import axios from 'axios';
import { urls } from '@/common/constants/const-url';

Vue.use(vuexI18n.plugin, store);
Vue.use(VueRouter);
Vue.use(Notifications);

Vue.prototype.$notifyError = function (message) {
    this.$notify({
        group: 'secondary',
        title: this.$t('error'),
        text: message,
        type: 'error-notify',
    });
};
Vue.prototype.$notifySuccsesfull = function (message) {
    this.$notify({
        group: 'secondary',
        title: this.$t('error'),
        text: message,
        type: 'success',
    });
};
new Vue({
    el: '#app-root',
    router: LoginRouter,
    components: { Login },
    store: store,
    created: function () {
        this.$i18n.add('ru', localeRu);
        this.$i18n.set('ru');
        axios.get(urls.urlApplicationConfig)
                .then(function (response) {
                if (response.data.isSuccessful) {
                    var config = response.data.viewModel;
                    config.authApplications.forEach(function (appConfig) {
                        if (appConfig.versionKey) {
                            window.addEventListener('message', function (event) {
                                if (event.data && event.data[appConfig.versionKey]) {
                                    localStorage.setItem(appConfig.versionKey, event.data[appConfig.versionKey]);
                                }
                            }, false);
                        }
                    });
                }});
    },
    template: '<router-view/>'
});


// WEBPACK FOOTER //
// ./login/main.ts